import { useEffect } from "react";
import { useSelector } from "react-redux";
import { selectUser } from "modules/auth/redux/selectors";
import {
  LOCAL_USER_TIMEZONE,
  FALLBACK_TIME_ZONE,
} from "modules/dateTime/constants";
import { useAppDispatch } from "store/hooks";
import { setAuth } from "modules/auth/redux/authSlice";
import useUserProfile from "../useUserProfile";

const TimezoneUpdate = () => {
  const { updateMyProfile } = useUserProfile();
  const user = useSelector(selectUser);
  const dispatch = useAppDispatch();

  useEffect(() => {
    const updateProfile = async () => {
      if (user?.profile?.timezone && LOCAL_USER_TIMEZONE === undefined) return;

      const data = await updateMyProfile({
        timezone: LOCAL_USER_TIMEZONE ?? FALLBACK_TIME_ZONE,
      });

      dispatch(setAuth(data));
    };

    if (!user) {
      return;
    }

    if (
      !user?.profile?.timezone ||
      LOCAL_USER_TIMEZONE !== user?.profile?.timezone
    ) {
      updateProfile();
    }
  }, [dispatch, updateMyProfile, user?.profile?.timezone, user]);

  return null;
};

export default TimezoneUpdate;
